<template>
  <div :class="previewMode ? '' : 'wf-border wf-p-2 wf-pt-0 wf-border-transparent hover:wf-border-gray-500 hover-trigger'">
    <div v-show="! previewMode" class="wf-relative wf-justify-end wf-flex">
      <button class="hover-target pricing-table-block-handle wf-text-gray-500"><i class="fas fa-arrows-alt"></i></button>
    </div>
    <div
      :contenteditable="! previewMode"
      class="wf-flex wf-justify-center wf-items-center wf-h-10 wf-w-full wf-text-sm"
      :class="classes"
      :style="styles"
      v-text="value"
      @input="emitUpdate"
    ></div>
  </div>
</template>

<script>
  import PricingTableBlock from '../contracts/PricingTableBlock'
  export default PricingTableBlock.extend({})
</script>